import React from "react"
import Barcode from "react-barcode"
import { MdClose } from "react-icons/md"
import { useSelector } from "react-redux"
import { useTranslation } from "react-i18next"

import {
  moment,
  thousandSeparator,
  formatMobilePhone,
  calculateItemSalePrice
} from "utils"
import { productUnitsSymbol } from "constant"
import classes from "./PlOrderLabelTemplateOther.module.scss"
import PlSpecificationItems from "./PlSpecificationItems"

const PlOrderLabelTemplate = (props) => {
  const { printData } = props

  const {
    date,
    code,
    items,
    total,
    note,
    subtotal,
    totalDiscount,
    deliveryFee,
    address,
    customerFullName,
    customerMobilePhone,
    addedBySystem,
    addedByFullName,
    branchAddress,
    branchContactNumber
  } = printData

  const [t] = useTranslation()

  const subdomain =
    useSelector(state => state.systemSettings.subdomain)

  const unitsMap = {}

  items.forEach((item) => {
    if (!!unitsMap[item.unit]) {
      unitsMap[item.unit] += item.quantity
    } else {
      unitsMap[item.unit] = item.quantity
    }
  })

  const units = []

  Object.keys(unitsMap).forEach(unit => {
    if (unit === "quantity" || unit === "dozen") {
      units.unshift(unit)

      return
    }

    units.push(unit)
  })

  return (
    <div className={classes["container"]}>
      <div className={classes["header"]}>
        <div className={classes["date"]}>
          <div className={classes["date-text"]}>
            {t("تاریخ")}: {moment(date).format("jYYYY/jMM/jDD")} -{" "}
            {t("شماره_فاکتور")}:
          </div>
          <div className={classes["barcode"]}>
            <Barcode
              height={18}
              fontSize={14}
              value={`${code}`}
            />
          </div>
        </div>

        <div className={classes["added-by"]}>
          <span>{t("طریق_سفارش")}:</span>{" "}
          {addedBySystem
            ? <span>{addedByFullName}</span>
            : <span>{t("سایت")}</span>
          }
        </div>

        {
          !!address &&
          <div className={classes["customer-details"]}>
            <div className={classes["full-name"]}>
              {t("گیرنده")}: <b>{address.recipientName || customerFullName}</b>
            </div>
            <div className={classes["address"]}>
              {t("استان")}: <b>{address.state}</b>{" "}
              {t("شهر")}: <b>{address.city}</b>{" "}
              {t("نشانی")}: <b>{address.address}</b>{" "}
              {t("منزل")}: <b>{address.recipientName}</b>{" "}
            </div>
            <div className={classes["mobile"]}>
              {t("کدپستی")}: <b>{address.zipCode}</b>{" "}
            </div>
            <div className={classes["mobile"]}>
              {t("تلفن")}:{" "}
              <b>
                {formatMobilePhone(
                  address.recipientPhoneNumber ||
                  customerMobilePhone
                )}
              </b>
            </div>
            {
              !!address.note &&
              <div className={classes["address-note"]}>
                {address.note}
              </div>
            }
          </div>
        }
      </div>

      {
        note &&
        <div className={classes["note"]}>
          {t("یادداشت")}: <b>{note}</b>
        </div>
      }

      <table className={classes["table"]}>
        <tr className={classes["header-table"]}>
          <th>
            {t("عنوان")}
          </th>
          <th>
            {t("واحد")}
          </th>
          <th>
            {t("مبلغ_واحد_تومان")}
          </th>
          <th>
            {t("مبلغ_کل_تومان")}
          </th>
        </tr>

        {items.map((item, i) =>
          <tr key={i}>
            <td>
              <div>
                {item.foodName}
              </div>
              <div>
                {item.optionName}
              </div>
              <PlSpecificationItems items={item.specificationItems}>
                {(specificationItem, siIndex) =>
                  <div
                    key={siIndex}
                    className={classes["option-name"]}
                  >
                    {specificationItem.name}
                    <MdClose />
                    {specificationItem.quantity * item.quantity}
                  </div>
                }
              </PlSpecificationItems>
            </td>
            <td className={classes[""]}>
              {item.quantity}{productUnitsSymbol[item.unit]}
            </td>
            <td className={classes[""]}>
              {thousandSeparator(
                calculateItemSalePrice(item),
                ""
              )}
            </td>
            <td className={classes[""]}>
              {thousandSeparator(
                calculateItemSalePrice(item) * item.quantity,
                ""
              )}
            </td>
          </tr>
        )}

        <tr>
          <td colSpan="1" className={classes["left"]}>
            {t("مجموع")}:
          </td>
          <td colSpan="1" className={classes["quantity"]}>
            {units.map((unit, i) =>
              ` ${unitsMap[unit]}${t(productUnitsSymbol[unit])}${units.length - 1 !== i ? " + " : ""}`
            )}
          </td>
          <td colSpan="2" className={classes[""]}>
            {thousandSeparator(subtotal)}
          </td>
        </tr>

        <tr>
          <td colSpan="2" className={classes["left"]}>
            {t("حمل_و_نقل")}:
          </td>
          <td colSpan="2" className={classes[""]}>
            {thousandSeparator(deliveryFee)}
          </td>
        </tr>

        {
          totalDiscount > 0 &&
          <tr>
            <td colSpan="2" className={classes["left"]}>
              {t("تخفیف")}:
            </td>
            <td colSpan="2" className={classes[""]}>
              {thousandSeparator(totalDiscount)}
            </td>
          </tr>
        }

        <tr className={classes["last-row"]}>
          <td colSpan="2" className={classes["left"]}>
            <b>
              {t("قیمت_نهایی")}:
            </b>
          </td>
          <td colSpan="2" className={classes[""]}>
            <b>
              {thousandSeparator(total)}
            </b>
          </td>
        </tr>
      </table>

      <div className={classes["branch"]}>
        {
          subdomain !== "bambi" &&
          <div className={classes["branch-address-wrapper"]}>
            <div className={classes["branch-address"]}>
              {t("فرستنده")}: <b>{branchAddress}</b>
            </div>

            <div className={classes["branch-contact"]}>
              {t("شماره_تماس")}: <b>{branchContactNumber}</b>
            </div>
          </div>
        }
      </div>
    </div>
  )
}

export default PlOrderLabelTemplate
